import React from 'react';
import { connect } from 'react-redux'

import { _setAxios, getParamTable } from '../../../lib/Helper';

import { Table, Row, Col, Divider, Breadcrumb, List, Button } from 'antd';
import { PageHeader } from 'components/header';
import { DoubleRightOutlined, DownloadOutlined } from '@ant-design/icons';
import AuthRedirect from '../../../components/AuthRedirect';
import { isAuth } from '../../../lib/Helper';
import { Link } from 'react-router-dom';

class JadwalMengajarDetail extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            id: this.props.match.params.id,
            header: {
                data1: [
                    {
                        title: "Tahun Ajaran",
                        description: "-",
                    },
                    {
                        title: "Status Kepegawaian",
                        description: "-",
                    },
                    {
                        title: "Nama PTK",
                        description: "-",
                    },
                ],
                data2: [
                    {
                        title: "Mata Pelajaran Utama",
                        description: "-",
                    },
                    {
                        title: "JTM",
                        description: "-",
                    },
                ]
            },
            table: {
                loading: false,
                data: [],
            },
            export: {
                loading: false
            }
        };
    }

    componentDidMount() {
        this.fetchTable()
    }

    fetchTable = () => {
        const { table } = this.state
        const params = getParamTable("default", table)
        this.fetch(params);
    }

    fetch = async (params = {}) => {
        this.setState({
            table: {
                ...params,
                loading: true
            }
        });
        _setAxios("jadwal/mengajar/" + this.props.match.params.id, "GET", params).then(resp => {
            if (resp.status === true) {
                const header = resp.data.data.header
                if(!header) {
                    this.setState({
                        table: {
                            ...params,
                            loading: false
                        }
                    })
                    return
                }

                const gelarDepan = header.gelar_depan ? header.gelar_depan : ""
                const nama = header.nama_lengkap ? " "+header.nama_lengkap : "-"
                const gelarBelakang = header.gelar_belakang ? ", "+header.gelar_belakang : ""
                const namaLengkap = gelarDepan + nama + gelarBelakang

                this.setState({
                    header: {
                        data1: [
                            {
                                title: "Tahun Ajaran",
                                description: header.thn_awal ? header.thn_awal + " - " + header.thn_akhir + " " + header.tipe_semester : "-",
                            },
                            {
                                title: "Status Kepegawaian",
                                description: header.status_kepegawaian ? header.status_kepegawaian : "-",
                            },
                            {
                                title: "Nama PTK",
                                description: namaLengkap,
                            },
                        ],
                        data2: [
                            {
                                title: "Mata Pelajaran Utama",
                                description: header.mata_pelajaran_nama ? header.mata_pelajaran_nama : "-",
                            },
                            {
                                title: "JTM",
                                description: header.total_jtm ? header.total_jtm : "0",
                            },
                        ]
                    },
                    table: {
                        ...params,
                        loading: false,
                        data: resp.data.data.table,
                    }
                });
            } else {
                this.setState({
                    table: {
                        ...params,
                        loading: false,
                    }
                })
            }
        })
    };


    onExport = () => {
        this.setState({
            export: {
                ...this.state.export,
                loading: true
            }
        });
        _setAxios("jadwal/export-mengajar", "POST", {
            tk_id: this.props.match.params.id
        }).then(resp => {
            if (resp.status === true) {
                setTimeout(function () {
                    window.open(resp.data?.data?.link, '_blank');
                }, 1000);
            } else {
                this.setState({
                    table: {
                        ...this.state.export,
                        loading: false,
                    }
                })
            }
        })
    };

    render() {
        const access = this.props.privilege.access["/kurikulum/jadwal"]
        if (!isAuth(this.props.privilege) || access === undefined) {
            return <AuthRedirect />
        }
        // const action = access.action

        const { table, header } = this.state;


        return (
            <>
                <PageHeader
                    style={{
                        padding: 0
                    }}
                    onBack={() => window.history.back()}
                    subTitle={<Breadcrumb style={{ margin: '16px 0' }} separator={<DoubleRightOutlined />}>
                        <Breadcrumb.Item>Kurikulum</Breadcrumb.Item>
                        <Breadcrumb.Item><Link to={`/kurikulum/jadwal?tab=1`}>Jadwal Mengajar</Link></Breadcrumb.Item>
                        <Breadcrumb.Item>Detail</Breadcrumb.Item>
                    </Breadcrumb>}
                />
                <Divider className='breadcrumb-line' orientation="left"></Divider>

                <PageHeader
                    className="site-page-header"
                    title="Jadwal Mengajar"
                />
                <div className="site-layout-background" style={{ padding: 24, minHeight: 360 }}>
                    <Row>
                        <Col xs={12}>
                            <List
                                itemLayout="horizontal"
                                dataSource={header.data1}
                                renderItem={item => (
                                    <List.Item>
                                        <List.Item.Meta
                                            title={<><div style={{ float: "left", minWidth: 50 }}>{item.title}</div> : <small style={{ color: "rgb(119 105 105)" }}>{item.description}</small></>}
                                        />
                                    </List.Item>
                                )}
                            />
                        </Col>
                        <Col xs={12}>
                            <List
                                itemLayout="horizontal"
                                dataSource={header.data2}
                                renderItem={item => (
                                    <List.Item>
                                        <List.Item.Meta
                                            title={<><div style={{ float: "left", minWidth: 50 }}>{item.title}</div> : <small style={{ color: "rgb(119 105 105)" }}>{item.description}</small></>}
                                        />
                                    </List.Item>
                                )}
                            />
                        </Col>
                        <Col xs={24}>
                            <Divider />
                            <Button style={{float: "right"}} icon={<DownloadOutlined/>} loading={this.state.export.loading} onClick={
                                this.onExport
                            }>Export</Button>
                        </Col>
                        <Col xs={24}>
                            <Table
                                columns={[
                                    {
                                        title: 'Jam Ke-',
                                        dataIndex: 'jam_ke',
                                        width: '5%',
                                    },
                                    {
                                        title: 'Senin',
                                        dataIndex: 'Senin',
                                    },
                                    {
                                        title: 'Selasa',
                                        dataIndex: 'Selasa',
                                    },
                                    {
                                        title: 'Rabu',
                                        dataIndex: 'Rabu',
                                    },
                                    {
                                        title: 'Kamis',
                                        dataIndex: 'Kamis',
                                    },
                                    {
                                        title: 'Jumat',
                                        dataIndex: 'Jumat',
                                    },
                                    {
                                        title: 'Sabtu',
                                        dataIndex: 'Sabtu',
                                    },
                                    {
                                        title: 'Minggu',
                                        dataIndex: 'Minggu',
                                    },
                                ]}
                                rowKey={record => record.id}
                                dataSource={table.data}
                                pagination={false}
                                loading={table.loading}
                                onChange={false}
                                size="small"
                            />
                        </Col>
                    </Row>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        privilege: state.privilege,
    }
}

export default connect(mapStateToProps)(JadwalMengajarDetail);
